import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

const orderRoutes: RouteConfig = {
  path: '/orders',
  component: Layout,
  redirect: 'noRedirect', // '/orders/list',
  name: 'Orders',
  meta: {
    title: 'order',
    icon: 'component',
    roles: ['Admin', 'ClientAdmin', 'ClientSuperUser']
  },

  children: [
    {
      path: 'create',
      component: () => import(/* webpackChunkName: "orders-create" */ '@/views/orders/create.vue'),
      name: 'CreateOrder',
      meta: {
        title: 'createOrder',
        icon: 'edit',
        roles: ['Admin', 'ClientAdmin', 'ClientSuperUser']
      }
    },
    {
      path: 'copy/:id(\\d+)',
      component: () => import(/* webpackChunkName: "orders-create" */ '@/views/orders/create.vue'),
      name: 'CopyOrder',
      meta: {
        title: 'copyOrder',
        noCache: true,
        activeMenu: '/orders/list',
        roles: ['Admin', 'ClientAdmin', 'ClientSuperUser'],
        hidden: true
      }
    },
    {
      path: 'edit/:id(\\d+)',
      component: () => import(/* webpackChunkName: "orders-edit" */ '@/views/orders/edit.vue'),
      name: 'EditOrder',
      meta: {
        title: 'editOrder',
        noCache: true,
        activeMenu: '/orders/list',
        roles: ['Admin', 'ClientAdmin', 'ClientSuperUser'],
        hidden: true
      }
    },
    {
      path: 'detail-tree/:id(\\d+)/:productGroup(\\w+)',
      component: () => import(/* webpackChunkName: "orders-edit" */ '@/views/orders/components/OrderDetailTree.vue'),
      name: 'OrderDetailTree',
      meta: {
        title: 'orderDetailTree',
        noCache: true,
        activeMenu: '/orders/list',
        roles: ['Admin', 'ClientSuperUser'],
        hidden: true
      }
    }
  ]
}

export default orderRoutes
